/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CalendarEventsResultV2,
  Email,
  FreeBusyResults,
  GetCalendarIntegrationStatusBatchRequest,
  IntegrationStatusBatchResultV2,
  IntegrationStatusResultV2,
  MapString,
  TenantIntegrationStatusResultV2,
  UserCalendarEventsV2Request,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "external-calendar";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns array of busy intervals for given user ids
   *
   * @name FreeBusy
   * @request GET:/v2/tenant/{tenantId}/user-free-busy
   * @secure
   */
  freeBusy = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userIds: string[];
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      FreeBusyResults,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/user-free-busy`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for freeBusy */
  freeBusyPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userIds: string[];
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/user-free-busy`, query);

  /**
   * @description Returns array of calendar events for given user id
   *
   * @name CalendarEventsV2
   * @request POST:/v2/tenant/{tenantId}/user-calendar-events
   * @secure
   */
  calendarEventsV2 = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
      showCanceled: boolean;
    },
    data: UserCalendarEventsV2Request,
    params: RequestParams = {},
  ) =>
    this.request<
      CalendarEventsResultV2,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/user-calendar-events`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendarEventsV2 */
  calendarEventsV2PathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
      showCanceled: boolean;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/user-calendar-events`, query);

  /**
   * @description Returns connected calendar email for given user id with integration status
   *
   * @name CalendarIntegrationStatus
   * @request GET:/v2/tenant/{tenantId}/calendar-integration-status
   * @deprecated
   * @secure
   */
  calendarIntegrationStatus = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      IntegrationStatusResultV2,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/calendar-integration-status`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendarIntegrationStatus */
  calendarIntegrationStatusPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/calendar-integration-status`, query);

  /**
   * @description Returns connected calendar email for given user id with integration status
   *
   * @name CalendarIntegrationStatus2
   * @request POST:/v2/tenant/{tenantId}/calendar-integration-status
   * @deprecated
   * @originalName calendarIntegrationStatus
   * @duplicate
   * @secure
   */
  calendarIntegrationStatus2 = (
    tenantId: string,
    data: GetCalendarIntegrationStatusBatchRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      IntegrationStatusBatchResultV2,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/calendar-integration-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendarIntegrationStatus2 */
  calendarIntegrationStatus2PathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/calendar-integration-status`);

  /**
   * @description Returns connected calendar with integration status of a tenant-wide connection
   *
   * @name AdminCalendarIntegrationStatus
   * @request GET:/v2/tenant/{tenantId}/admin-calendar-integration-status
   * @secure
   */
  adminCalendarIntegrationStatus = (
    tenantId: string,
    query: {
      /**
       * is used to hint calendar integration type used by a tenant
       * @pattern [^\s\\/]+
       */
      callerUserId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      TenantIntegrationStatusResultV2,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/admin-calendar-integration-status`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for adminCalendarIntegrationStatus */
  adminCalendarIntegrationStatusPathGetter = (
    tenantId: string,
    query: {
      /**
       * is used to hint calendar integration type used by a tenant
       * @pattern [^\s\\/]+
       */
      callerUserId: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/admin-calendar-integration-status`, query);
}
